// @ts-nocheck
import { useMediaQuery } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Lock, EmojiEvents, MonetizationOn } from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import XomeLogo from "../../assets/xome-logo-blaze.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { addSignUpData } from "../../redux/slice/userSlice";
import { Helmet } from 'react-helmet';

const theme = createTheme();

const RegisterPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Detect if the screen is md or larger
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    password: '',
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = 'First Name is required';
    if (!formData.lastName) newErrors.lastName = 'Last Name is required';
    if (!formData.mobileNumber) newErrors.mobileNumber = 'Mobile Number is required';
    if (!formData.email) newErrors.email = 'Email Address is required';
    if (!formData.password) newErrors.password = 'Password is required';
    if (formData.mobileNumber.length !== 10) newErrors.mobileNumber = "Mobile number must be 10 digitNumber"
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // Dispatch the action to update the Redux state
    if (validate()) {
      dispatch(addSignUpData(formData));
      // navigate('/kyc-kyb');
    }
  };
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>Sign Up | Remote Bidding</title>
        <meta name="description" content="Register for Remote Bidding to participate in live auctions, bid from anywhere, and manage your funds online." />
      </Helmet>
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh", // Ensures the container takes full viewport height
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "center", xl: "normal" },
          backgroundColor: "#F8F8F8",
        }}
      >
        {/* Left Section (hidden on mobile using MUI's sx prop) */}
        {isDesktop && (
          <Box
            sx={{
              width: "50%",
              p: 10,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h5"
              textAlign={"center"}
              sx={{ color: "#f97316", fontWeight: "bold" }}
            >
              REMOTE BIDDING
            </Typography>
            <hr style={{ borderTop: "2px solid #d1d5db", margin: "20px 0" }} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                justifyContent: "center",
                flexGrow: 1,
                maxHeight: "60dvh",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Lock sx={{ color: "#f97316", mr: 2 }} />
                <Typography sx={{ color: "#6b7280", fontSize: "14px" }}>
                  Bid live from anywhere—no limits, just endless opportunities.
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <EmojiEvents sx={{ color: "#f97316", mr: 2 }} />
                <Typography sx={{ color: "#6b7280", fontSize: "14px" }}>
                  Participate in multiple auctions at once, expanding your
                  chances to win.
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <MonetizationOn sx={{ color: "#f97316", mr: 2 }} />
                <Typography sx={{ color: "#6b7280", fontSize: "14px" }}>
                  Seamlessly manage your funds and complete all formalities
                  online for a smooth experience.
                </Typography>
              </Box>
            </Box>
          </Box>
        )}

        {/* Right Section - Sign Up Form */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            backgroundColor: "#fff",
            p: { xs: 2, sm: 10 },
            pt: { xs: 5, sm: 5 },
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh", // Ensure it occupies full height
          }}
        >
          <Box sx={{ mb: 4 }}>
            {/* Logo */}
            <img
              src={XomeLogo}
              alt="Xome Logo"
              style={{ height: "50px", marginBottom: "10px", margin: "0 auto" }}
            />
            <Typography
              textAlign={"center"}
              sx={{ fontWeight: "bold", color: "#FF5C39" }}
            >
              There’s No Place Like Xome
            </Typography>

            <hr style={{ borderTop: "2px solid #d1d5db", margin: "20px 0" }} />

            <Typography
              variant="h6"
              textAlign={"center"}
              sx={{ fontWeight: "bold" }}
            >
              Sign Up
            </Typography>
            <Typography sx={{ color: "#6b7280", fontSize: "14px" }}>
              Register to unlock live remote bidding, participate in multiple
              auctions, and manage your funds online. Already have an account?{" "}
              <Link to="/signin" style={{ color: "#f97316" }}>
                Sign in.
              </Link>
            </Typography>
          </Box>

          {/* Form Fields */}
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
              <TextField
                name="firstName"
                label="First Name"
                fullWidth
                size="small"
                error={Boolean(errors.firstName)}
                helperText={errors.firstName}
                onChange={handleChange}
              />
              <TextField
                name="lastName"
                label="Last Name"
                fullWidth
                size="small"
                error={Boolean(errors.lastName)}
                helperText={errors.lastName}
                onChange={handleChange}
              />
            </Box>
            <TextField
              name="mobileNumber"
              label="Mobile Number"
              fullWidth
              size="small"
              error={Boolean(errors.mobileNumber)}
              helperText={errors.mobileNumber}
              sx={{ mb: 2 }}
              onChange={handleChange}
            />
            <TextField
              name="email"
              label="Email Address"
              fullWidth
              size="small"
              error={Boolean(errors.email)}
              helperText={errors.email}
              sx={{ mb: 2 }}
              onChange={handleChange}
            />
            <TextField
              name="password"
              label="Password"
              type="password"
              fullWidth
              size="small"
              error={Boolean(errors.password)}
              helperText={errors.password}
              sx={{ mb: 2 }}
              onChange={handleChange}
            />
            {/* Checkbox for terms */}

            {/* Sign Up Button */}
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#FF5C39",
                "&:hover": { backgroundColor: "#FF5C39" },
                py: 1,
                display: "block",
                mx: "auto",
              }}
            >
              Sign Up
            </Button>

            {/* Terms note */}
            <Typography
              sx={{
                color: "#6b7280",
                fontSize: "12px",
                mt: 2,
                backgroundColor: "#FCF8E3",
                p: 1,
              }}
            >
              By providing your information, you hereby agree that you are not a
              resident of the European Union nor are you present in the European
              Union at the time of your submission.
            </Typography>

            <Typography sx={{ color: "#6b7280", fontSize: "14px", mt: 1 }}>
              I accept the{" "}
              <a
                target="_blank"
                href="https://www.xome.com/pages/terms-of-use"
                style={{ color: "#FF5C39" }}
              >
                Terms of Use
              </a>
              ,{" "}
              <a
                target="_blank"
                href="https://www.xome.com/pages/privacy-policy"
                style={{ color: "#FF5C39" }}
              >
                Privacy Policy
              </a>
              , and{" "}
              <a
                target="_blank"
                href="https://www.xome.com/auctions/auction-eventagreement"
                style={{ color: "#FF5C39" }}
              >
                Auction Participation Agreement
              </a>
              .
            </Typography>
          </form>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default RegisterPage;
